import { inject, Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    MaybeAsync,
    Resolve,
    RouterStateSnapshot,
} from '@angular/router';
import { ApiService } from './api.service';
import { PageDataPreloaderService } from './page-data-preloader.service';
import { forkJoin, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PageResolver implements Resolve<any> {
    private apiService: ApiService = inject(ApiService);
    private pageDataPreloader = inject(PageDataPreloaderService);

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): MaybeAsync<any> {
        const pathSegments = state.url
            .split(/[?#]/, 1)[0]
            .split('/')
            .filter(Boolean);

        let languageCode = pathSegments[0] ?? route.params['languageCode'];
        if (languageCode !== 'de' && languageCode !== 'en') {
            languageCode = 'de';
        }

        const pageSegments = pathSegments.slice(1);
        let slug = pageSegments[0] ?? route.params['slug'];
        if (
            (slug === 'hof' || slug === 'apartment') &&
            pageSegments[1]
        ) {
            slug = `${slug}/${pageSegments[1]}`;
        }

        const context = {
            pageSlug: slug,
            pageSegments,
            languageCode,
            secondarySlug: pageSegments[2],
        };

        return forkJoin({
            page: this.apiService.getPageBySlugGraphql(slug, languageCode),
            preloadedData: this.pageDataPreloader.preload(context),
        }).pipe(
            map(({ page, preloadedData }) => {
                const components = page.data.pages[0]?.components ?? [];

                for (const preloadedComponent of preloadedData) {
                    const component = components.find(
                        (pageComponent) =>
                            pageComponent.__component ===
                            preloadedComponent.component,
                    );
                    if (component) {
                        Object.assign(component, preloadedComponent.data);
                    }
                }

                return page;
            }),
        );
    }
}
